import { FRUser, TokenManager } from '@forgerock/javascript-sdk';

const reAuthenticate = async () => {
    try {
        await TokenManager.getTokens({
            forceRenew: true,
            login: 'redirect',
        });
    } catch (err) {
        console.error('Reauthentication failed', err);
    }
};

const logoutUser = async () => {
    try {
        await FRUser.logout();
        localStorage.clear();
        sessionStorage.clear();
        await reAuthenticate();
    } catch (error) {
        console.error('Not able to log out:', error);
    }
};

export const clearUser = () => {
    localStorage.removeItem("wasLoggedInBefore");
    localStorage.removeItem('token');
    const isLogoutValid = Boolean(localStorage.getItem(`FR-SDK-${process.env.REACT_APP_CLIENTID}`));
    const isFrUser = Boolean(sessionStorage.getItem("FrUser"));//multi tab support

    if (isLogoutValid || isFrUser) {
        logoutUser();
    }
};